export default "__VITE_ASSET__19e816fe__"